import { render, staticRenderFns } from "./achievementFooter.vue?vue&type=template&id=4bee0189&scoped=true&"
import script from "./achievementFooter.vue?vue&type=script&lang=js&"
export * from "./achievementFooter.vue?vue&type=script&lang=js&"
import style0 from "./achievementFooter.vue?vue&type=style&index=0&id=4bee0189&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bee0189",
  null
  
)

export default component.exports